import { Messages } from '../../../../codegen/Localize';
import { IGroupInfo } from '../../../../ts/models/IGroupInfo';
import { ISiteUserInfo } from '../../../../ts/models/ISiteUserInfo';
import { removeSiteUsersFromGroup } from '../../../actions/spaces/GroupMenuActions';
import { SessionUserSelectors } from '../../../selectors/SessionInfoSelectors';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { isSingleSelectSiteUserGuest } from './IEntityActionHelpers';

export const SiteUserRemoveFromGroupAction: IEntityAction<ISiteUserInfo, {}> = {
  name: EntityActionNames.SiteUserRemoveFromGroup,
  translateName: Messages.remove_action,
  isVisible: (targetItems: ISiteUserInfo[], state: AppState) => {
    const group = state.spaceInfo.item as IGroupInfo;
    return targetItems.length > 0
      && SessionUserSelectors.canManageUsers(state)
      && !isSingleSelectSiteUserGuest(targetItems)
      && state.spaceInfo.spaceType === 'group'
      && !group.isAllUsersGroup;
  },
  isClickable: (_availableActions: {}, _targetItems: ISiteUserInfo[], _state: AppState) => {
    return true;
  },
  createReduxAction: (targetItems: ISiteUserInfo[]) => removeSiteUsersFromGroup(targetItems)
};
